import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-info-payment',
  templateUrl: './modal-info-payment.component.html',
  styleUrls: ['./modal-info-payment.component.scss']
})
export class ModalInfoPaymentComponent {
  @Output() modalInfoPaymentChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isInfoPaymentModal: boolean = false;
  public isDarkBackground: boolean = false;

  infoPaymentModalShow() {
    this.modalInfoPaymentChange.emit();
    this.isInfoPaymentModal = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isInfoPaymentModal = false;
    this.isDarkBackground = false;
  }
}
